import React from 'react'
import { FirestoreDocument } from 'react-firestore'

import classifyPerson from '../../actions/classifyPerson'
import Error from '../misc/Error'
import Person from './Person'
import {
  PersonBubble,
  PersonBubbleBackground,
} from '../../styles/lists'

const PersonContainer = ({history, person}) => (
  <div>
    <PersonBubbleBackground onClick={() => history.push('/')} />
    <PersonBubble>
      <FirestoreDocument path={`people/${person.id}`}>
        { ({error, isLoading, data}) => {
          if (error) {
            return <Error error={error} />
          }

          if (isLoading) {
            return <p>loading...</p>
          }
          
          if (!isLoading && data.length === 0) {
            return <Error />
          }

          return <Person person={classifyPerson(data)} history={history} />
        }}
      </FirestoreDocument>
    </PersonBubble>
  </div>
)

export default PersonContainer



// WEBPACK FOOTER //
// ./src/views/person/index.js